import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { color, keys, Legend } from 'highcharts';
import { QaReportService } from '../services/qa-report.service';
import { MatSelect } from '@angular/material/select';
import { DatePipe } from '@angular/common';
// import moment from 'moment';
import { FormControl } from '@angular/forms';
import { NotifierService } from 'angular-notifier';
import { Router } from '@angular/router';
import { GoogleChartComponent } from 'angular-google-charts';
import { SidePanelService } from 'src/app/shared/services/side-pannel/side-pannel.service';
// import { L } from '@angular/cdk/keycodes';

@Component({
  selector: 'app-qa-dashboard',
  templateUrl: './qa-dashboard.component.html',
  styleUrls: ['./qa-dashboard.component.scss'],
  providers: [DatePipe]
})

export class QaDashboardComponent implements OnInit, AfterViewInit {
  public mainGraphOptions: any;
  public mainGraphType: any;
  public mainGraphColContainer: any = [];
  public mainGraphDataContainer: any = [];
  public mainGraphTitle: string = "";
  public mainGraphObject: any = {};

  public yoyResultObject: any = {};
  public yoyGraphObject: any = {};
  public yoyGraphTitle: string = "";
  public yoyPieGraphObject = {};
  public yoyPieGraphTitle: string = "";
  public rejByMonthGraphObject: any = {};
  public rejByMonthGraphTitle: string = "";
  public rejByZoneGraphObject: any = {};
  public rejByZoneGraphTitle: string = "";
  public rejByOfficeGraphObject: any = {};
  public rejByOfficeGraphTitle: string = "";
  public rejByOfficeGraphList: any = [];

  public rejByJobGraphObject: any = {};
  public rejByJobGraphTitle: string = "";

  public rejByReasonGraphObject: any = {};
  public rejByReasonGraphTitle: string = "";

  public x_axis_container: any = [];
  public subGraphContainer: any = [];
  public defaultChart: string = "LineChart";
  public isLineChart: boolean = true;
  public isShowChart: boolean = true;
  public isLoadingMainGraph: boolean = true;
  public isLoadingZoneGraph: boolean = true;
  private isConfigInitiated: boolean = false;

  public isNegativeYTD: boolean = false;
  public differeceYTD: number = 0;
  public differeceYTDTitle: string = "";
  public yoyFullData: any[] =[];

  @ViewChild('OfficeChart', {static: false}) OfficeChart: ElementRef;
  @ViewChild(GoogleChartComponent) zonalChart: GoogleChartComponent;
  // formattedDate
  startMonth
  endMonth
  selectedYear

  public yearFilter = [];
  public dateFilter = {"startDate":'',"endDate":'',"selectedYear":''};
  public selectedYearFilter:any = '';
  public dashboardFilter = {}
  // @ViewChild('canvas') canvasRef: ElementRef | undefined;
  disableDates = (date: Date) => {
    // return 'mat-calendar-body-disabled';  // Use Angular Material's built-in class
    return 'disabled-date';
  };
  // date: moment.Moment = moment();
  constructor(
    private datePipe: DatePipe,
    public qaReportService: QaReportService,
    public notifier:NotifierService,
    public router:Router,
    public sidePanelService:SidePanelService
  ) {
    this.dashboardFilter = {};
    this.sidePanelService.initSideDrawer('qa-report');
    this.qaReportService.initQaDashBoardConfigEmitter
    .subscribe(() => {
        this.setDefaultDates();
        if (this.router.url.includes('qa-report/qa-dashboard')) {
          this.getYoyGraph();
          this.getRejByMonthGraph();
          this.getRejByZoneGraph();
          this.getRejByOfficeGraph();
          this.getRejByJobGraph();
          this.getRejByReasonGraph();
        }
        this.isConfigInitiated = true;
      })
    // this.qaReportService.initQaDashBoardEmitter
    //   .subscribe((data: string) => {
    //     // this.resetMainChartSetting();
    //     // this.initQaDashBoardGraph(data);
    //   })
    // this.qaReportService.initSubGraphsEmitter
    //   .subscribe((data: string) => {
    //     // this.subGraphContainer = [];
    //     // this.setupSubDashBoardGraph(data);
    //   });
      
  }
  ngAfterViewInit(): void {
  }

  ngOnInit(): void {
    this.qaReportService.isOpen = false;
    this.qaReportService.reSetQaReportConfig();
  }

  setDefaultDates(){
    if (this.qaReportService.qaDashboardConfig && this.qaReportService.qaDashboardConfig['filters'] && this.qaReportService.qaDashboardConfig['filters']["year"]) {
      this.yearFilter = Object.values(this.qaReportService.qaDashboardConfig['filters']["year"]);
      if (this.yearFilter && this.yearFilter.length) {
        this.selectedYearFilter = this.getMaxValue(this.yearFilter);
        this.dateFilter.selectedYear = this.selectedYearFilter +""
        this.dateFilter.startDate = this.selectedYearFilter+'-01-01 00:00:00'
        this.dateFilter.endDate = this.selectedYearFilter+'-12-31 23:59:59'
        this.dashboardFilter["date"] = [];
        this.dashboardFilter["date"].push(this.dateFilter.startDate)
        this.dashboardFilter["date"].push(this.dateFilter.endDate)
      }
    }
  }

  getMaxValue(data: any[]) {
    const values = data.map(item => item.value);
    return Math.max(...values); // Returns the maximum value
  }
  // setDefaultDates(){
  //   this.endMonth = new Date();
  //   this.startMonth = new Date();
  //   this.selectedYear = new Date();
    
  //   switch (this.qaReportService.defaultGraphFrequency) {
  //     case 'year':
  //       this.startMonth.setFullYear(this.startMonth.getFullYear() -1);
  //       // this.startMonth.setFullYear(this.startMonth.getFullYear() - 3);
  //       break;
  //     case 'month':
  //       this.startMonth.setFullYear(this.startMonth.getFullYear() -1);
  //       break;
  //     case 'quarter':
  //       this.startMonth.setFullYear(this.startMonth.getFullYear() -1);
  //       break;                        
  //     default:
  //       this.startMonth.setFullYear(this.startMonth.getFullYear()-1);
  //       // this.startMonth.setFullYear(this.startMonth.getFullYear() - 3);
  //       break;
  //     }
  //     this.selectedYear.setFullYear(this.selectedYear.getFullYear());
  //     // this.selectedYear.setDate(1);
  //     this.startMonth.setDate(1);
  //     this.startMonth.toISOString();
  //     const actualStartMonth = this.startMonth.getMonth() + 1; 
  //     const actualEndMonth = this.endMonth.getMonth() + 1; 
  //     this.dateFilter.selectedYear = this.startMonth.getFullYear() +""
  //     this.dateFilter.startDate = this.startMonth.getFullYear()+'-'+actualStartMonth+'-01 00:00:00'
  //     this.dateFilter.endDate = this.endMonth.getFullYear()+'-'+actualEndMonth+'-'+this.endMonth.getDate()+' 23:59:59'
  //     this.dashboardFilter["date"] = [];
  //     this.dashboardFilter["date"].push(this.dateFilter.startDate)
  //     this.dashboardFilter["date"].push(this.dateFilter.endDate)
      
  // }

  // getMainGraph(){
  //   let body = {}
  //   body = (this.qaReportService.qaDashboardConfig && this.qaReportService.qaDashboardConfig['graphs'] && this.qaReportService.qaDashboardConfig['graphs']['zone'] && this.qaReportService.qaDashboardConfig['graphs']['zone']['req_body']) ? this.qaReportService.qaDashboardConfig['graphs']['zone']['req_body'] : {"qa_type": "dashboard","trend": false,"percentage": true};
  //   body['group'] = [
  //         this.qaReportService.defaultGraphFrequency,
  //         "zone",
  //         "count"
  //       ];
  //   body['row'] = "zone";
  //   body['col'] = this.qaReportService.defaultGraphFrequency
  //   body['filters'] = {...this.dashboardFilter};
  //   this.isLoadingMainGraph = true;
  //   this.qaReportService.getQaDashBoardData(body);
  // }

  // getSubGraphs(){
  //   let body = {}
  //   body = (this.qaReportService.qaDashboardConfig && this.qaReportService.qaDashboardConfig['graphs'] && this.qaReportService.qaDashboardConfig['graphs']['office_zone'] && this.qaReportService.qaDashboardConfig['graphs']['office_zone']['req_body'])?this.qaReportService.qaDashboardConfig['graphs']['office_zone']['req_body']:{"qa_type": "dashboard","trend": false,"percentage": true};
  //   body['group'] = [
  //         this.qaReportService.defaultGraphFrequency,
  //         "office_zone",
  //         "count"
  //       ];
  //   body['row'] = this.qaReportService.defaultGraphFrequency;
  //   body['col'] = "office_zone";
  //   body['filters'] = {...this.dashboardFilter};
  //   this.isLoadingZoneGraph = true;
  //   this.qaReportService.getQaDashboardSubgraph(body);
  // }

  // gridFilter(selectCtrl: MatSelect, compObj, item) {
  //   if (item['value'] === 'all') {
  //     if (!this.qaReportService.appliedFilter[item['key']]) {
  //       this.qaReportService.appliedFilter[item['key']] = [];
  //       this.qaReportService.copyappliedFilter[item['key']] = [];

  //     }
  //     let isExit = this.qaReportService.copyappliedFilter[item['key']].findIndex(v => v === item['value']);
  //     if (isExit >= 0) {
  //       this.qaReportService.appliedFilter[item['key']] = [];
  //       this.qaReportService.copyappliedFilter[item['key']] = [];
  //       selectCtrl.options.forEach(option => {
  //         option.deselect();
  //       });
  //     } else {
  //       Object.keys(compObj).forEach(key => {
  //         this.qaReportService.copyappliedFilter[item['key']].push(compObj[key]['value']);
  //         if (compObj[key]['value'] != 'all') {
  //           this.qaReportService.appliedFilter[item['key']].push(compObj[key]['value']);
  //         }
  //       })
  //       selectCtrl.options.forEach(option => {
  //         if (this.qaReportService.copyappliedFilter[item['key']].includes(option.value)) {
  //           option.select();
  //         }
  //       });
  //     }
  //   } else {
  //     if (!this.qaReportService.appliedFilter[item['key']]) {
  //       this.qaReportService.appliedFilter[item['key']] = [];
  //       this.qaReportService.copyappliedFilter[item['key']] = [];
  //     }
  //     let isExit = this.qaReportService.appliedFilter[item['key']].findIndex(v => v === item['value']);
  //     if (isExit >= 0) {
  //       this.qaReportService.appliedFilter[item['key']].splice(isExit, 1);
  //       let isAllExit = this.qaReportService.appliedFilter[item['key']].findIndex(v => v === 'all');
  //       if (isAllExit >= 0) {
  //         this.qaReportService.appliedFilter[item['key']].splice(isAllExit, 1);
  //       }
  //       this.qaReportService.copyappliedFilter[item['key']] = this.qaReportService.appliedFilter[item['key']];
  //     } else {
  //       this.qaReportService.appliedFilter[item['key']].push(item['value']);
  //       this.qaReportService.copyappliedFilter[item['key']] = this.qaReportService.appliedFilter[item['key']];
  //     }
  //   }
  // }

  // graphtoggle() {
  //   this.isLineChart != this.isLineChart;
  //   this.defaultChart = this.isLineChart ? 'LineChart' : 'ColumnChart';
  //   // this.defaultChart = this.isLineChart ? 'LineChart' : 'BarChart';
  //   this.isShowChart = false
  //   this.mainGraphObject['type'] = this.defaultChart
  //   this.subGraphContainer.forEach(formItem => {
  //     formItem['type'] = this.defaultChart;
  //   });
  //   setTimeout(() => {
  //     this.isShowChart = true;
  //   }, 100)
  // }

  // resetMainChartSetting() {
  //   this.mainGraphObject = {};
  //   this.x_axis_container = [];
  // }

  // frequencyFilter(val){
  //   this.qaReportService.defaultGraphFrequency = val;
  //   this.setDefaultDates();
  //   this.getMainGraph();
  //   this.getSubGraphs();
  // }

  // initQaDashBoardGraph(data) {
  //   this.mainGraphObject['type'] = this.defaultChart
  //   this.mainGraphObject['options'] = {
  //     legend: { position: 'right' },
  //     width: 900,
  //     height: 300,
  //     lineWidth: 4,
  //     annotations: {
  //       textStyle: {
  //         fontSize: 10,
  //       }
  //     },
  //     hAxis: {
  //       format:'####',
  //       title:this.getFrequencyLabel(this.qaReportService.defaultGraphFrequency),
  //       textStyle: {
  //         fontSize: 12,
  //         bold: true,
  //         color: '#a1a2a3'
  //       },
  //     },
  //     vAxis: {
  //       title:'Rejection %',
  //       textStyle: {
  //         fontSize: 12,
  //         bold: true,
  //         color: '#a1a2a3'
  //       },
  //     },
      
  //     series: []
  //   }
  //   this.mainGraphObject['data'] = [];
  //   this.mainGraphObject['col'] = ['Years'];
  //   this.setupMainDashBoardGraph(data);
  //   this.isLoadingMainGraph = false;
  //   this.isShowChart = true;
  // }

  // setupMainDashBoardGraph(data) {
  //   Object.keys(data.headers).forEach((key) => {
  //     if (key.includes('row')) {
  //       this.mainGraphTitle = this.qaReportService.firstLetterCapitalizer(data.headers[key]['name']);
  //     }
  //     if (!key.includes("row")) {
  //       data.headers[key]['name'] = data.headers[key]['name']+"";
  //       let obj = { 'key': key, 'value': data.headers[key]['name'] };
  //       this.x_axis_container.push(obj);
  //     }
  //   })
  //   let annotationCols = []
  //   data.data.forEach((va, index) => {
  //     this.mainGraphObject['col'].push(va.row);
  //     let lineObj = { color: this.qaReportService.graphLineColors[index],labelInLegend: va.row,annotations: {alwaysOutside: true} }
  //     if (va.row == 'Overall') {
  //       lineObj['lineDashStyle'] = [4, 4];
  //     }
  //     this.mainGraphObject['options']['series'].push(lineObj);
  //     annotationCols.push({ "role": "annotation" })
  //   })
  //   this.mainGraphObject['col'] = [...this.mainGraphObject['col'],...annotationCols];
  //   this.x_axis_container.forEach((va) => {
  //     let _arr = [];
  //     let annotationData = [];
  //     _arr.push(va['value']);
  //     data.data.forEach((v) => {
  //       _arr.push(parseFloat(v[va['key']]));
  //       annotationData.push(v[va['key']]);
  //     })
  //     _arr = [..._arr,...annotationData];
  //     this.mainGraphObject['data'].push(_arr);
  //   })

  //   this.mainGraphObject.data = this.sortGraphData(this.mainGraphObject.data,this.qaReportService.defaultGraphFrequency)
    
  // }

  // setupSubDashBoardGraph(result) {
  //   let data = result['data'];
  //   var subGraphs = {};
  //   var subGraphList = [];
  //   Object.keys(result['headers']).forEach((key) => {
  //     if (!key.includes("row")) {
  //       let keys = key.split("#");
  //       if (!subGraphs[keys[0]]) {
  //         subGraphs[keys[0]] = {}
  //         subGraphs[keys[0]][keys[1]] = result['headers'][key];

  //         let graphData = [];
  //         data.forEach((item,index) => {
  //           let tempArr = [];
  //           tempArr.push(item.row+'');
  //           item[key] = item[key]+"";
  //           let number = parseFloat(item[key].replace('%', ''));
  //           tempArr.push(number);
  //           graphData.push(tempArr);
  //         });
  //         subGraphList.push({
  //           'type':this.defaultChart,
  //           'options':{
  //             legend: { position: 'right' },
  //             chartArea:{
  //               left:30,
  //               top:20,
  //               width: '65%',
  //               height: '70%'
  //             },
  //             lineWidth: 4,
  //             hAxis: {
  //               format:'####',
  //               title:this.getFrequencyLabel(this.qaReportService.defaultGraphFrequency),
  //               textStyle: {
  //                 fontSize: 8,
  //                 bold: true,
  //                 color: '#a1a2a3'
  //               },
  //             },
  //             vAxis: {
  //               format:'####',
  //               title:'Rejection %',
  //               textStyle: {
  //                 fontSize: 8,
  //                 bold: true,
  //                 color: '#a1a2a3'
  //               },
  //             },
  //             series: [
  //               { color: this.qaReportService.graphLineColors[0],labelInLegend: keys[1] } 
  //             ]
  //           },
  //           'title':keys[0],
  //           'data':graphData,
  //           'col':['Years',keys[1]]
  //         })
  //       }else{
  //         subGraphs[keys[0]][keys[1]] = result['headers'][key];
  //         var graph = subGraphList.find(item =>{return item.title == keys[0]});
  //         if (graph) {
  //           data.forEach((item,index) => {
  //             let number = parseFloat(item[key].replace('%', ''));
  //             graph.data[index].push(number);
  //           });
  //           graph['col'].push(keys[1])
  //           graph['options']['series'].push({ color: this.qaReportService.graphLineColors[graph['options']['series'].length], labelInLegend: keys[1] })
  //         }
  //       }
  //     }
  //   })
  //   subGraphList.map((item,gIndex)=>{
  //     item.data = this.sortGraphData(item.data,this.qaReportService.defaultGraphFrequency);

  //     item.col.push("Overall")
  //     item['options']['series'].push({lineDashStyle:[4, 4], color: this.qaReportService.graphLineColors[item['options']['series'].length], labelInLegend: "Overall"});
  //     item.data.forEach((record, rIndex) => {
  //       let totalPoints = 0
  //       let totalOffices = item.data[rIndex].length - 1;
  //       record.forEach((rdata,ri) => {
  //         if (ri && ri > 0) {
  //           totalPoints = totalPoints + rdata;
  //         }
  //       });
  //       let overAll = totalPoints/totalOffices;
  //       record.push(overAll);
  //     });
  //     // item.data = this.sortGraphData(item.data,this.qaReportService.defaultGraphFrequency)
  //   })
  //   this.isLoadingZoneGraph = false;
  //   this.subGraphContainer = subGraphList;
  // }

  sortGraphData(data,type){
    let sortedData = []
    
    switch (type) {
      case "quarter":
        sortedData = data.filter(item => item[0] !== 'Overall') // Exclude 'Overall' from sorting
        .sort((a, b) => {
          const quarterA = this.parseQuarter(a[0]);
          const quarterB = this.parseQuarter(b[0]);
          if (quarterA.year === quarterB.year) {
            return quarterA.quarter - quarterB.quarter;
          }
          return quarterA.year - quarterB.year;
        });
        break;
      case "month":
        sortedData = data.sort((a, b) => {
          if (a[0] === "Overall" || b[0] === "Overall") {
            return 0; // Keep "Overall" at the end
          }
          const dateA = this.parseMonth(a[0]);
          const dateB = this.parseMonth(b[0]);
          return dateA.getTime() - dateB.getTime(); // Compare dates
        });
        break;
      default:
        sortedData = data;
        break;
    }
    return sortedData;
  }

  parseQuarter(quarter) {
    const match = quarter.match(/Q(\d)#(\d{4})/);
    return match ? { quarter: parseInt(match[1]), year: parseInt(match[2]) } : null;
  };

  parseMonth(monthYear: string): Date {
    const [month, year] = monthYear.split(' ');
    return new Date(`${month} 1, ${year}`);
  }

  formatDate(date: Date): string {
    return this.datePipe.transform(date, 'MM/yyyy')!;
  }
  changeDateMonth(event: any, datepicker: any, key) {
    const selectedDate = new Date(event);
    const year = selectedDate.getFullYear();
    const month = selectedDate.getMonth();  
    const actualMonth = month + 1;  
    // debugger
    if (key == 'startDate') {
      this.startMonth =  new Date() 
      this.startMonth.setFullYear(year, month , 1);
      this.dateFilter.startDate = year+'-'+actualMonth+'-01 00:00:00'
    }else{
      const lastDateOfMonth = new Date(year, month + 1, 0);
      this.endMonth =  new Date() 
      this.endMonth.setFullYear(year, month +1 , 0);
      // this.endMonth.setFullYear(year, month , lastDateOfMonth);
      this.dateFilter.endDate = year+'-'+actualMonth+'-'+this.endMonth.getDate()+' 23:59:59'
    }
    datepicker.close(); // Close the datepicker after selection
  }

  onYearSelection(year) {
      this.dateFilter.selectedYear = year +""
      this.dateFilter.startDate = year+'-01-01 00:00:00'
      this.dateFilter.endDate = year+'-12-31 23:59:59'
      this.dashboardFilter["date"] = [];
      this.dashboardFilter["date"].push(this.dateFilter.startDate)
      this.dashboardFilter["date"].push(this.dateFilter.endDate)
      this.applyFilter();
  }
  // onYearSelected(event: any, datepicker: any, key) {
  //   const selectedDate = new Date(event);
  //   const year = selectedDate.getFullYear();
  //   if (key == 'startDate') {
  //     this.startMonth =  new Date() 
  //     this.startMonth.setFullYear(year, 0 , 1);
  //     this.dateFilter.startDate = year+'-01-01 00:00:00'
  //   }else if (key == 'endDate') {
  //     // const lastDateOfMonth = new Date(year, month + 1, 0);
  //     this.endMonth =  new Date() 
  //     this.endMonth.setFullYear(year, 12 , 0);
  //     // this.endMonth.setFullYear(year, month , lastDateOfMonth);
  //     this.dateFilter.endDate = year+'-12-'+this.endMonth.getDate()+' 23:59:59'
  //   }else{
  //     this.selectedYear =  new Date() 
  //     this.selectedYear.setFullYear(year, 0 , 1);
  //     this.dateFilter.selectedYear = year+''

  //     this.endMonth =  new Date() 
  //     this.endMonth.setFullYear(year, 12 , 0);
  //     this.dateFilter.startDate = year+'-01-01 00:00:00';
  //     this.dateFilter.endDate = year+'-12-'+this.endMonth.getDate()+' 23:59:59';
  //     this.applyFilter();
  //   }
  //   datepicker.close(); // Close the datepicker after selection
  // }

  // Optional: Handle when the datepicker is closed
  onMonthpickerClosed() {
  }
  onYearpickerClosed() {
  }
  applyFilter(qa_type?:string){

    if (this.dateFilter && this.dateFilter.startDate  && this.dateFilter.startDate !='') {
      this.dashboardFilter["date"] = [];
      this.dashboardFilter["date"].push(this.dateFilter.startDate)
      this.dashboardFilter["date"].push(this.dateFilter.endDate)
    }
    this.dashboardFilter['base_zone'] = [];
    this.setYoyPieGraph();
    this.getRejByMonthGraph();
    this.getRejByZoneGraph();
    this.getRejByOfficeGraph();
    this.getRejByJobGraph();
    this.getRejByReasonGraph();
  }

  getFrequencyLabel(label){
    let newLabel = "";
    switch (label) {
      case 'year':
        newLabel = 'Years'
        break;
      case 'month':
        newLabel = 'Months'
        break;
      case 'quarter':
        newLabel = 'Quarters'
        break;                        
      default:
        newLabel = 'Years'
        break;
    }
    return newLabel;
  }

  setYoyPieGraph(){
    let yearData = "";

    yearData = this.yoyResultObject.data[0][this.dateFilter.selectedYear] && this.yoyResultObject.data[0][this.dateFilter.selectedYear] !='' ?this.yoyResultObject.data[0][this.dateFilter.selectedYear]:'NA' ;
    this.yoyPieGraphTitle = "FY ("+this.dateFilter.selectedYear+")";
    this.yoyPieGraphObject = {
      type :'PieChart',
      col : ['data', 'Percentage'],
      data : [
        [yearData, 100]
      ],   
      options : {
        // title: 'Browser market shares at a specific website, 2014',
        legend: { position: 'none' },
        pieSliceText: 'label', 
        pieStartAngle: 100,
        chartArea: { width: '50%', height: '90%' },
        tooltip: {
          trigger: 'none'  // Optionally, you can also use 'focus' or 'none'
          // isHtml: true,           // Ensures you can customize the tooltip content
          // format: 'data: %s' // This will only show the category in the tooltip, not the value
        }
      },
      width : 300,
      height : 300
    }
  }
  getYoyGraph(){
    this.yoyGraphObject = {};
    let body = {}
    body = this.qaReportService.qaDashboardConfig['graphs']['year']['req_body'];

    // this.yoyResultObject = result['result'];

    this.qaReportService.callQaDashBoardData(body).subscribe(data => {
      if(data['status'] == 1){
        // this.initYoyGraph(this.yoyResultObject);
        this.yoyResultObject = data['result'];
        // this.setYoyPieGraph();
        this.initYoyGraph(this.yoyResultObject);

        // this.getRejByMonthGraph();
      }else{
        this.notifier.notify("error",'Something went wrong');
      }
    });
  }
 
  initYoyGraph(data) {
    this.yoyGraphObject['type'] = "ColumnChart"
    this.yoyGraphObject['options'] = {
      legend: { position: 'none' },
      width: 260,
      height: 160,
      chartArea:{
        left:30,
        top:10,
        width: '100%',
        height: '70%'
      },
      lineWidth: 4,
      annotations: {
        // alwaysOutside: true,  // Ensures the text is displayed outside the points
        textStyle: {
          fontSize: 10,
          auraColor: 'none',
          color: 'white'
        },
        lineWidth: 0,
      },
      hAxis: {
        format:'####',
        title:"Years",
        textStyle: {
          fontSize: 9,
          bold: true,
          color: '#a1a2a3'
        },
      },
      vAxis: {
        title:'Rejection %',
        minValue: 0,
        textStyle: {
          fontSize: 9,
          bold: true,
          color: '#a1a2a3'
        },
      },
      series: {
        0: { 
          bar: { groupWidth: '20%' }  // Adjust this percentage to control the width of columns
        }
      },
      animation: {
        startup: true,
        duration: 1500,
        easing: 'out',
      },
      cursor: 'pointer'

    }
    this.yoyGraphObject['data'] = [];
    this.yoyGraphObject['col'] = ['Years',"Rejection", { "role": 'style' },{ "role": "annotation" }];
    // this.yoyGraphObject['col'] = ['Years',"Rejection",{ "role": "annotation" }];
    this.yoyFullData = [];
    this.yoyGraphTitle = "Year on Year";
    Object.keys(data.headers).forEach((key,index) => {
      if (!key.includes("row")) {
        let _arr = [];
        _arr.push(key+'');
        // _arr.push(data.headers[key]['name']+'');
        data.data.forEach((dataV) => {
          _arr.push(parseFloat(dataV[key]));
          _arr.push(this.qaReportService.graphLineColors[index % this.qaReportService.graphLineColors.length]);
          _arr.push(parseFloat(dataV[key]).toFixed(2) + '');
          // _arr.push(dataV[key] + '');
        })
        // this.yoyGraphObject['data'].push(_arr);
        this.yoyFullData.push(_arr);
      }
    })

    const lastFour = this.yoyFullData.slice(-4);
    this.yoyGraphObject.data = JSON.parse(JSON.stringify(lastFour));
    this.yoyGraphObject.data = this.sortGraphData(this.yoyGraphObject.data,this.qaReportService.defaultGraphFrequency)
    this.isLoadingMainGraph = false;
    this.isShowChart = true;
    console.log(this.yoyGraphObject)
    this.calculateYTD(null, this.yoyGraphObject.data.length - 1);
  }

  getRejByMonthGraph(){
    this.rejByMonthGraphObject = {};
    let body = {}
    body = this.qaReportService.qaDashboardConfig['graphs']['month']['req_body'];
    body['filters'] = {...this.dashboardFilter};
    this.qaReportService.callQaDashBoardData(body).subscribe(data => {
      if(data['status'] == 1){
        // this.initRejByMonthGraph(result['result']);
        this.initRejByMonthGraph(data['result']);
      }else{
        this.notifier.notify("error",'Something went wrong');
      }
    });
  }

  initRejByMonthGraph(data) {
    this.rejByMonthGraphObject['type'] = "LineChart"
    this.rejByMonthGraphObject['options'] = {
      legend: { position: 'none' },
      width: 380,
      height: 160,
      chartArea:{
        left:40,
        top:20,
        width: '100%', 
        height: 'auto'
      },
      lineWidth: 4,
      annotations: {
        alwaysOutside: true,  // Ensures the text is displayed outside the points
        textStyle: {
          fontSize: 8,
          color: 'black',
          // color: 'black',
          auraColor: 'none'
        },
        lineWidth: 0,
        
      },
      hAxis: {
        format:'####',
        title:"Months",
        textStyle: {
          fontSize: 9,
          bold: true,
          color: '#a1a2a3'
        },
      },
      vAxis: {
        title:'Rejection %',
        minValue: 0,
        textStyle: {
          fontSize: 9,
          bold: true,
          color: '#a1a2a3'
        },
      },
      series: {
        0: {
          pointSize: 5, // Size of the circle at each data point
          pointShape: 'circle', // Shape of the point (circle)
        }
      }
    }
    this.rejByMonthGraphObject['data'] = [];
    this.rejByMonthGraphObject['col'] = ['Years',"Rejection",{ "role": "annotation" }];
    this.rejByMonthGraphTitle = "Month on Month ("+this.dateFilter.selectedYear+")";
    // this.rejByMonthGraphTitle = "QA Rejection FY 2024 BY Month";
    Object.keys(data.headers).forEach((key) => {
      if (!key.includes("row")) {
        let _arr = [];
        _arr.push(data.headers[key]['name']);
        data.data.forEach((dataV) => {
          _arr.push(parseFloat(dataV[key]));
          _arr.push(parseFloat(dataV[key]).toFixed(2) + '');
          // _arr.push(dataV[key] + '');
        })
        this.rejByMonthGraphObject['data'].push(_arr);
      }
    });
    if (this.rejByMonthGraphObject['data'].length == 0) {
      this.rejByMonthGraphObject['data'].push(['No Data',0,0]);
    }
    this.rejByMonthGraphObject.data = this.sortGraphData(this.rejByMonthGraphObject.data,this.qaReportService.defaultGraphFrequency)
    console.log("rejByMonthGraphObject =>", this.rejByMonthGraphObject)
    this.isLoadingMainGraph = false;
    this.isShowChart = true;
  }

  getRejByZoneGraph(){
    this.rejByZoneGraphObject = {};
    let body = {}
    body = this.qaReportService.qaDashboardConfig['graphs']['zones']['req_body'];
    body['filters'] = {...this.dashboardFilter};
    this.qaReportService.callQaDashBoardData(body).subscribe(data => {
      if(data['status'] == 1){
        this.initRejByZoneGraph(data['result']);
        // this.getRejByOfficeGraph();
      }else{
        this.notifier.notify("error",'Something went wrong');
      }
    });
  }

  initRejByZoneGraph(data) {
    this.rejByZoneGraphObject['type'] = "ColumnChart"
    this.rejByZoneGraphObject['options'] = {
      legend: { position: 'none' },
      width: 380,
      height: 160,
      chartArea:{
        left:35,
        top:20,
        width: '100%',
        height: 'auto'
      },
      lineWidth: 4,
      annotations: {
        textStyle: {
          fontSize: 10,
          // color: 'white',  // White text color
          bold: true,
          auraColor: 'none',
        },
        lineWidth: 0,
      },
      hAxis: {
        format:'####',
        title:"Zones",
        textStyle: {
          fontSize: 9,
          bold: true,
          color: '#a1a2a3'
        },
      },
      vAxis: {
        title:'Rejection %',
        minValue: 0,
        textStyle: {
          fontSize: 9,
          bold: true,
          color: '#a1a2a3'
        },
      },
      animation: {
        startup: true,
        duration: 1500,
        easing: 'out',
      },
      series: {}
    }
    this.rejByZoneGraphObject['data'] = [];
    this.rejByZoneGraphObject['col'] = ['Years',"Rejection",{ "role": 'style' },{ "role": "annotation" }];

    this.rejByZoneGraphTitle = "Zone wise ("+this.dateFilter.selectedYear+")";
    Object.keys(data.headers).forEach((key,index) => {
      if (!key.includes("row")) {
        let _arr = [];
        _arr.push(data.headers[key]['name']);
        data.data.forEach((dataV) => {
          _arr.push(parseFloat(dataV[key]));
          _arr.push(this.qaReportService.graphLineColors[index % this.qaReportService.graphLineColors.length]);
          _arr.push(parseFloat(dataV[key]).toFixed(2) + '');
          // _arr.push(dataV[key] + '');
        })
        this.rejByZoneGraphObject['data'].push(_arr);
      }
    })
    this.rejByZoneGraphObject.data = this.sortGraphData(this.rejByZoneGraphObject.data,this.qaReportService.defaultGraphFrequency)
    if (this.rejByZoneGraphObject['data'].length == 0) {
      this.rejByZoneGraphObject['data'].push(['No Data',0,0,0]);
    }
    this.isLoadingMainGraph = false;
    this.isShowChart = true;
  }

  getRejByJobGraph(){
    this.rejByJobGraphObject = {};
    let body = {}
    body = this.qaReportService.qaDashboardConfig['graphs']['job']['req_body'];
    body['filters'] = {...this.dashboardFilter};
    this.qaReportService.callQaDashBoardData(body).subscribe(data => {
      if(data['status'] == 1){
        this.initRejByJobGraph(data['result']);
      }else{
        this.notifier.notify("error",'Something went wrong');
      }
    });
  }

  initRejByJobGraph(data) {
    this.rejByJobGraphObject['type'] = "ColumnChart"
    this.rejByJobGraphObject['options'] = {
      legend: { position: 'none' },
      width: 250,
      height: 160,
      chartArea:{
        left:40,
        top:20,
        width: '100%',
        height: 'auto'
      },
      lineWidth: 4,
      annotations: {
        textStyle: {
          fontSize: 10,
          auraColor: 'none',
          color: 'white'
        },
        lineWidth: 0,
      },
      hAxis: {
        format:'####',
        title:"Job type",
        textStyle: {
          fontSize: 8,
          bold: true,
          color: '#a1a2a3'
        },
      },
      vAxis: {
        title:'Rejection %',
        minValue: 0,
        textStyle: {
          fontSize: 8,
          bold: true,
          color: '#a1a2a3'
        },
      },
      animation: {
        startup: true,
        duration: 1500,
        easing: 'out',
      },
      series: {}
    }
    this.rejByJobGraphObject['data'] = [];
    this.rejByJobGraphObject['col'] = ['Years',"Rejection",{ "role": 'style' },{ "role": "annotation" }];
    this.rejByJobGraphTitle = "Job type wise ("+this.dateFilter.selectedYear+")";
    Object.keys(data.headers).forEach((key,index) => {
      if (!key.includes("row")) {
        let _arr = [];
        data.data.forEach((dataV, dataIndex) => {
          if (dataIndex == 0) {
            _arr.push(data.headers[key]['name']);
          }
          _arr.push(parseFloat(dataV[key]));
          _arr.push(this.qaReportService.graphLineColors[index % this.qaReportService.graphLineColors.length]);
          _arr.push(parseFloat(dataV[key]).toFixed(2) + '');
          // _arr.push(dataV[key] + '');
        })
        if (_arr.length ) {
          this.rejByJobGraphObject['data'].push(_arr);
        }
      }
    })
    this.rejByJobGraphObject.data = this.sortGraphData(this.rejByJobGraphObject.data,this.qaReportService.defaultGraphFrequency)
    if (this.rejByJobGraphObject['data'].length == 0) {
      this.rejByJobGraphObject['data'].push(['No Data',0,0,0]);
    }
    console.log(this.rejByJobGraphObject)
    this.isLoadingMainGraph = false;
    this.isShowChart = true;
  }

  getRejByReasonGraph(){
    this.rejByReasonGraphObject = {};
    let body = {}
    body = this.qaReportService.qaDashboardConfig['graphs']['reason']['req_body'];
    body['filters'] = {...this.dashboardFilter};
    this.qaReportService.callQaDashBoardData(body).subscribe(data => {
      if(data['status'] == 1){
        this.initRejByReasonGraph(data['result']);
      }else{
        this.notifier.notify("error",'Something went wrong');
      }
    });
  }

  initRejByReasonGraph(data) {
    this.rejByReasonGraphObject['type'] = "ColumnChart"
    this.rejByReasonGraphObject['options'] = {
      legend: { position: 'none' },
      width: 290,
      height: 160,
      chartArea:{
        left:35,
        top:20,
        width: '100%',
        height: 'auto'
      },
      lineWidth: 4,
      annotations: {
        textStyle: {
          fontSize: 10,
          color: 'white',  // White text color
          bold: true,
          auraColor: 'none',
        },
        lineWidth: 0,
      },
      hAxis: {
        format:'####',
        title:"Reason",
        textStyle: {
          fontSize: 9,
          bold: true,
          color: '#a1a2a3'
        },
      },
      vAxis: {
        title:'Rejection %',
        minValue: 0,
        textStyle: {
          fontSize: 9,
          bold: true,
          color: '#a1a2a3'
        },
      },
      animation: {
        startup: true,
        duration: 1500,
        easing: 'out',
      },
      series: {}
    }
    this.rejByReasonGraphObject['data'] = [];
    this.rejByReasonGraphObject['col'] = ['Years',"Rejection",{ "role": 'style' },{ "role": "annotation" }];

    this.rejByReasonGraphTitle = "Reason wise ("+this.dateFilter.selectedYear+")";
    Object.keys(data.headers).forEach((key,index) => {
      if (!key.includes("row")) {
        let _arr = [];
        _arr.push(data.headers[key]['name']);
        data.data.forEach((dataV) => {
          _arr.push(parseFloat(dataV[key]));
          _arr.push(this.qaReportService.graphLineColors[index % this.qaReportService.graphLineColors.length]);
          _arr.push(parseFloat(dataV[key]).toFixed(2) + '');
          // _arr.push(dataV[key] + '');
        })
        this.rejByReasonGraphObject['data'].push(_arr);
      }
    })
    this.rejByReasonGraphObject.data = this.sortGraphData(this.rejByReasonGraphObject.data,this.qaReportService.defaultGraphFrequency)
    if (this.rejByReasonGraphObject['data'].length == 0) {
      this.rejByReasonGraphObject['data'].push(['No Data',0,0,0]);
    }
    this.isLoadingMainGraph = false;
    this.isShowChart = true;
  }

  getRejByOfficeGraph(){
    this.rejByOfficeGraphObject = {};
    this.rejByOfficeGraphList = [];
    let body = {};
    body = this.qaReportService.qaDashboardConfig['graphs']['offices']['req_body'];
    body['filters'] = {...this.dashboardFilter};
    if (!(this.dashboardFilter && this.dashboardFilter['base_zone'] && this.dashboardFilter['base_zone'].length)) {
      // this.dashboardFilter['base_zone'] = ["North"];
      body['filters']['base_zone'] = ["North"];
      delete this.dashboardFilter['base_zone'];
    }
    this.rejByOfficeGraphTitle = "Offices wise ("+this.dateFilter.selectedYear+")";
    this.qaReportService.callQaDashBoardData(body).subscribe(data => {
      if(data['status'] == 1){
        this.initRejByOfficeGraph(data['result']);
      //  if (this.dashboardFilter && this.dashboardFilter['base_zone'] && this.dashboardFilter['base_zone'].length) {
      //    this.initRejByOfficeGraph(data['result']);
      //  }
      //  else{
      //    this.initRejByAllOfficeGraph(data['result']);
      //  }
      }else{
        this.notifier.notify("error",'Something went wrong');
      }
    });
  }

  initRejByOfficeGraph(result) {
    let data = result['data'];
    var officeGraphs = {};
    var officeGraphList = [];
    // this.rejByOfficeGraphTitle = "QA Rejection By Offices";
    Object.keys(result['headers']).forEach((key) => {
      if (!key.includes("row")) {
        let keys = key.split("#");
        if (!officeGraphs[keys[0]]) {
          officeGraphs[keys[0]] = {}
          officeGraphs[keys[0]][keys[1]] = result['headers'][key];

          let graphData = [];
          data.forEach((item,index) => {
            let tempArr = [];
            // tempArr.push(item.row+'');
            tempArr.push(keys[1]+'');
            item[key] = item[key]+"";
            let number = parseFloat(item[key].replace('%', ''));
            tempArr.push(number);
            tempArr.push(this.qaReportService.graphLineColors[index % this.qaReportService.graphLineColors.length]);
            tempArr.push(number.toFixed(2) + '');
            // tempArr.push(number.toFixed(1) + '%');
            graphData.push(tempArr);
          });
          if (graphData.length == 0) {
            graphData.push(['No Data',0,0,0]);
          }
          
          officeGraphList.push({
            'type':"ColumnChart",
            'options':{
              legend: { position: 'none' },
              // width: 500,
              // height: 300,
              width: 380,
              height: 160,
              chartArea:{
                left:35,
                top:20,
                width: '100%',
                height: 'auto'
              },
              lineWidth: 4,
              annotations: {
                textStyle: {
                  fontSize: 10,
                  color: 'white',  // White text color
                  bold: true,
                  auraColor: 'none',
                },
                lineWidth: 0,
              },
              hAxis: {
                format:'####',
                title:keys[0],
                textStyle: {
                  fontSize: 9,
                  bold: true,
                  color: '#a1a2a3'
                },
              },
              vAxis: {
                format:'####',
                title:'Rejection %',
                minValue: 0,
                textStyle: {
                  fontSize: 9,
                  bold: true,
                  color: '#a1a2a3'
                },
              },
              // series: [
              //   { color: this.qaReportService.graphLineColors[0],labelInLegend: keys[1] } 
              // ]
              animation: {
                startup: true,
                duration: 1500,
                easing: 'out',
              },
              series: {
                0: { 
                  bar: { groupWidth: '20%' }  // Adjust this percentage to control the width of columns
                }
              }
            },
            'title':keys[0],
            'data':graphData,
            'col':['Years',"Rejection",{ "role": 'style' },{ "role": "annotation" }]
          })
        }else{
          officeGraphs[keys[0]][keys[1]] = result['headers'][key];
          var graph = officeGraphList.find(item =>{return item.title == keys[0]});
          if (graph) {
            data.forEach((item) => {
              let tempArr = [];
              tempArr.push(keys[1]+'');
              item[key] = item[key]+"";
              let number = parseFloat(item[key].replace('%', ''));
              tempArr.push(number);
              tempArr.push(this.qaReportService.graphLineColors[graph.data.length % this.qaReportService.graphLineColors.length]);
              tempArr.push(number.toFixed(2) + '');
              // tempArr.push(number.toFixed(1) + '%');
              graph.data.push(tempArr);
              // graph.data[index].push(number);
            });
            // graph['col'].push(keys[1])
            // graph['options']['series'].push({ color: this.qaReportService.graphLineColors[graph['options']['series'].length]})
          }
        }
      }
    })
  //  if (officeGraphList.length && officeGraphList.length == 1) {
  //   officeGraphList[0]['options']['width'] = 900;
  //   officeGraphList[0]['options']['height'] = 300;
  //  }
    this.rejByOfficeGraphList = [officeGraphList[0]];
    this.isLoadingZoneGraph = false;
  }

  initRejByAllOfficeGraph(data) {
    this.rejByOfficeGraphObject['type'] = "ColumnChart"
    this.rejByOfficeGraphObject['options'] = {
      legend: { position: 'none' },
      chartArea:{
        left:30,
        top:20,
        width: '100%',
        height: 'auto'
      },
      width: 250,
      height: 180,
      lineWidth: 4,
      annotations: {
        // alwaysOutside: true,  // Ensures the text is displayed outside the points
        textStyle: {
          fontSize: 8,
          color: 'black',
          // auraColor: 'none'
        }
      },
      hAxis: {
        format:'####',
        title:"Offices",
        textStyle: {
          fontSize: 10,
          bold: true,
          color: '#a1a2a3'
        },
      },
      vAxis: {
        title:'Rejection %',
        minValue: 0,
        textStyle: {
          fontSize: 10,
          bold: true,
          color: '#a1a2a3'
        },
      },
      series: []
    }
    this.rejByOfficeGraphObject['data'] = [];
    this.rejByOfficeGraphObject['col'] = ['Years',"Rejection",{ "role": 'style' },{ "role": "annotation" }];
    Object.keys(data.headers).forEach((key,index) => {
      if (!key.includes("row")) {
        let _arr = [];
        let keys = key.split("#");
        _arr.push(keys[1]);
        // _arr.push(data.headers[key]['name']);
        data.data.forEach((dataV) => {
          _arr.push(parseFloat(dataV[key]));
          _arr.push(this.qaReportService.graphLineColors[index % this.qaReportService.graphLineColors.length]);
          _arr.push(parseFloat(dataV[key]).toFixed(1) + '%');
        })
        this.rejByOfficeGraphObject['data'].push(_arr);
      }
    })
    if (this.rejByOfficeGraphObject['data'].length == 0) {
      this.rejByOfficeGraphObject['data'].push(['No Data',0,0,0]);
    }
    // this.rejByOfficeGraphObject.data = this.sortGraphData(this.rejByOfficeGraphObject.data,this.qaReportService.defaultGraphFrequency)
    this.rejByOfficeGraphList = [this.rejByOfficeGraphObject];
    this.isLoadingMainGraph = false;
    this.isShowChart = true;
  }
 
  onColumnClick(event: any): void {
    const selection = event.selection;
    if (selection && selection.length > 0) {
      const selectedRow = selection[0].row;
      const clickedData = this.rejByZoneGraphObject.data[selectedRow];
      this.dashboardFilter['base_zone'] = [clickedData[0]];
      // this.dashboardFilter['zone'] = [clickedData[0]];
      this.rejByOfficeGraphList = [];
      this.getRejByOfficeGraph();
      this.OfficeChart.nativeElement.focus();
      this.OfficeChart.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
    }
  }

  calculateYTD(event: any, index?:number): void {   
    var clickedData = [] 
    var colIndex = index;
    if (index) {
      clickedData = this.yoyGraphObject.data[index];
      this.differeceYTD = this.yoyGraphObject.data[index][1] - this.yoyGraphObject.data[index - 1][1];
    } else {
      const selection = event.selection;
      if (selection && selection.length > 0) {
        const selectedRow = selection[0].row;
        colIndex = selectedRow;
        clickedData = this.yoyGraphObject.data[selectedRow];
        if (selectedRow == 0) {
          this.differeceYTD = this.yoyGraphObject.data.length < this.yoyFullData.length ? clickedData[1] - this.yoyFullData[this.yoyFullData.length - 5][1] : clickedData[1];
        }else{
          this.differeceYTD = clickedData[1] - this.yoyGraphObject.data[selectedRow - 1][1];
        }
        if (clickedData[0] && clickedData[0] !='') {
          this.onYearSelection(clickedData[0].split(' ')[clickedData[0].split(' ').length - 1]);
        }
      }
    } 
    let prevYear = Number(this.dateFilter.selectedYear) - 1;
    // console.log("colIndex ===> ",colIndex)
    this.differeceYTDTitle = clickedData[0].includes("YTD") ? clickedData[0] +" Vs FY "+prevYear : this.yoyGraphObject.data.length < this.yoyFullData.length ? "FY "+clickedData[0] +" Vs FY "+prevYear : colIndex==0 ? "FY "+clickedData[0] : "FY "+clickedData[0] +" Vs FY "+prevYear;
    // this.differeceYTDTitle = "YTD Feb "+this.dateFilter.selectedYear +" Vs FY "+prevYear;
    if (this.differeceYTD < 0) {
      this.differeceYTD = this.differeceYTD * -1;
      this.isNegativeYTD = true;
    }else{
      this.isNegativeYTD = false;
    }
    this.differeceYTD = Number(this.differeceYTD.toFixed(2));
  }

  // onColumnClick(event: any) {
  //   // const selectedItem = event.selectedItem;
  //   const selectedItem = event.selection[0];
  //   if (selectedItem) {
  //     const selectedRow = selectedItem.row;
  //     this.handleColumnClick(selectedRow);
  //   }
  // }

  // handleColumnClick(selectedRow: number) {
  //   const columns = document.querySelectorAll('.google-visualization-column');
  //   columns.forEach((column, index) => {
  //     if (index === selectedRow) {
  //       column.classList.add('clicked-column');
  //     } else {
  //       column.classList.remove('clicked-column');
  //     }
  //   });
  // }

  // onColumnClick(event: any): void {
  //   const selection = event.selection;
  //   if (selection && selection.length > 0) {
  //     const selectedRow = selection[0].row;
  //     const clickedData = this.rejByZoneGraphObject.data[selectedRow];
  //     this.dashboardFilter['base_zone'] = [clickedData[0]];
  //     this.rejByOfficeGraphList = [];

  //     const colIndex = selection[0].column; // Get the clicked column index
  //     const columnElement = document.querySelectorAll('.google-visualization-column')[colIndex] as HTMLElement;
  //     if (columnElement) {
  //       columnElement.style.backgroundColor = '#ff9900';  // Change background color
  //       columnElement.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.5)'; // Add box shadow effect
  //     }
  //     this.getRejByOfficeGraph();
  //     this.OfficeChart.nativeElement.focus();
  //     this.OfficeChart.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
  //   } else {
  //   }
  // }

  // onChartReady() {
  //   setTimeout(() => {
  //     // Wait a bit for the chart to be fully rendered
  //     const chartElement = document.querySelector('google-chart');
  //     const columns = document.querySelectorAll('.google-visualization-column');
  //     if (chartElement) {
  //       const chart = chartElement['chart'];
  //       // Attach mouseover event to columns
  //       google.visualization.events.addListener(chart, 'onmouseover', (e: any) => {
  //         const columns = document.querySelectorAll('.google-visualization-column');
  //         if (columns[e.target.row]) {
  //           const selectedElement = columns[e.target.row] as HTMLElement;
  //           selectedElement.classList.add('google-visualization-column-hover');
  //         }
  //       });

  //       // Attach mouseout event to columns
  //       google.visualization.events.addListener(chart, 'onmouseout', (e: any) => {
  //         const columns = document.querySelectorAll('.google-visualization-column');
  //         if (columns[e.target.row]) {
  //           const selectedElement = columns[e.target.row] as HTMLElement;
  //           selectedElement.classList.remove('google-visualization-column-hover');
  //         }
  //       });
  //     }
  //   }, 500);  // Small delay to allow chart elements to render
  // }

  // onChartReady() {
  //   const chart = document.querySelector('google-chart');
  //   setTimeout(() => {
    
  //     if (chart) {
  //       google.visualization.events.addListener(chart, 'onmouseover', (e) => {
  //         const selectedElement = document.querySelectorAll('.google-visualization-column')[e.target.row];
  //         selectedElement?.classList.add('google-visualization-column-hover');
  //       });
    
  //       google.visualization.events.addListener(chart, 'onmouseout', (e) => {
  //         const selectedElement = document.querySelectorAll('.google-visualization-column')[e.target.row];
  //         selectedElement?.classList.remove('google-visualization-column-hover');
  //       });
  //     }
  //   }, 500);
  // }


  getGridColumns(): number {
    return (this.rejByOfficeGraphList.length && this.rejByOfficeGraphList.length > 1) ? 2 : 1;
  }

  navigateToReports(){
    this.router.navigate(['/qa-report/rejection-on-yoy']);
  }
}
